import type { TimelineDuration, TimelineWindow, TimelineMode } from '../../../../model/timeline';

export type APIProps = {
	timelineMode: TimelineMode;
	timelineDuration: TimelineDuration;
	timelineWindow: TimelineWindow;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => null;
